import { Stack, Typography } from "@mui/material";
import { componentMapper, ComponentMapperKeys } from "../../../constant";

const columns = [{ maxWidth: "140px" }, { maxWidth: "100%" }];

export const TrendTable = ({
  title,
  rows,
}: {
  title: string;
  rows: {
    type: ComponentMapperKeys;
    value: never;
  }[][];
}) => {
  if (!rows || !Array.isArray(rows)) return null;

  return (
    <Stack gap="32px">
      {title && (
        <Typography
          component="h5"
          sx={{
            color: "#333333",
            fontSize: "16px",
            fontWeight: 600,
            lineHeight: "22px",
          }}
        >
          {title}
        </Typography>
      )}
      {rows.map((row, index) => (
        <Stack
          flexDirection="row"
          gap="32px"
          paddingBottom="16px"
          key={index}
          borderBottom={
            index === rows.length - 1 ? "none" : "1px solid #D9D9D9"
          }
        >
          {row.map(({ type, value }, i) => (
            <Stack
              maxWidth={columns[i].maxWidth}
              width="100%"
              alignSelf="flex-start"
            >
              {componentMapper[type](value as any)}
            </Stack>
          ))}
        </Stack>
      ))}
    </Stack>
  );
};
